import React from "react";
import {Footer, Header} from "./index";
import Metadata from "../../Metadata";

function Layout({children, headerImage = false, route = false, routeId = "homepage"}) {
    const classes = ["container", route && "subpage", routeId].filter(Boolean).join(" ");

    return (
        <div className={classes}>
            <Metadata />
            <Header headerImage={headerImage} />
            <div className={"content"}>{children}</div>
            <Footer />
        </div>
    );
}

export default Layout;
